export const complaintDictionaries = new Map<string, string>()
    .set("violation", "violation_amcu")
    .set("remedies_type", "requested_remedies_type");
